import { CallDirectionTypes, CallDispositionTypes, CallRetentionPolicyTypes } from 'generated/graphql-types';

import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { ConfirmationDialogService } from 'src/app/common-components/confirmation-dialog/confirmation-dialog.service';
import { setHideRecordingDate } from 'src/app/common-components/helpers/call-logs-helper';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { AccountDetailApiService } from '../../account-details/services/account-detail-api.service';
import { FileOption } from '../../prompt-details/models/file.option.interface';
import { CallDetailsPrivileges } from '../models/call-details-privileges';
import { CallLogsOrderingOptions, CallLogsRegisterOptions } from '../models/call-logs-register-options';
import { CallLogsRegisterListItem } from '../models/call-logs-register-results.model';
import { ListenToRecordingModel } from '../state/call-logs-register.actions';
import { selectQuickFilters } from '../state/call-logs-register.reducer';

@Component({
   encapsulation: ViewEncapsulation.None,
   selector: 'ndt-call-logs-register-view',
   styleUrls: ['./call-logs-register-view.component.scss'],
   templateUrl: './call-logs-register-view.component.html',
   standalone: false,
})
export class CallLogsRegisterViewComponent extends EntityRegisterView<
   CallLogsRegisterListItem,
   CallLogsRegisterOptions,
   CallLogsOrderingOptions
> {
   protected selectQuickFilters(): (state: object) => CallLogsRegisterOptions | null {
      return selectQuickFilters;
   }
   @ViewChild('picker') picker: MatDatepicker<Date>;

   @Input() callDetailsPrivileges: CallDetailsPrivileges;

   @Input() isSystemUser: boolean;

   @Output() openDialog = new EventEmitter<{ callLogs: CallLogsRegisterListItem }>();

   @Output() listen = new EventEmitter<ListenToRecordingModel>();

   callRetentionPolicyTypeId: CallRetentionPolicyTypes | null;

   currentAccount$: Observable<number | null>;

   hideRecordingDate: string;

   constructor(
      public store: Store,
      private accountDetailApiService: AccountDetailApiService,
      private dialogService: ConfirmationDialogService
   ) {
      super(store);
      this.currentAccount$ = store.select(getSelectedAccountId);

      this.currentAccount$
         .pipe(
            take(1),
            filter((accountId: number | null): accountId is number => {
               return accountId != null;
            })
         )
         .subscribe((accountId: number) => {
            this.fetchAccountDetails(accountId);
         });
   }

   onOpenDialog(callLogs: CallLogsRegisterListItem) {
      this.openDialog.emit({ callLogs: callLogs });
   }

   onListen(callLogs: CallLogsRegisterListItem) {
      let callRecordingFiles: Array<FileOption> = [];
      if (callLogs.callRecordingFile) {
         callRecordingFiles.push(callLogs.callRecordingFile);
      }
      // if (callLogs.callRecordingCallDetailsConnection?.items){
      //    callLogs.callRecordingCallDetailsConnection?.items.forEach(value => {
      //       if(value.callRecording.file){
      //          let tempFile : FileOption = {
      //             fileId: value.callRecording.file.fileId,
      //             fileName: value.callRecording.file.fileName,
      //             fileToken: value.callRecording.file.fileToken,
      //          };
      //          callRecordingFiles.push(tempFile);
      //       }
      //    })
      // }
      this.listen.emit({
         callRecordingId: callLogs.callRecordingId,
         files: callRecordingFiles,
      });
   }

   getRouterLink(id: number) {
      return '';
   }

   fetchAccountDetails(accountId: number): void {
      this.accountDetailApiService.getAccountDetails(accountId).subscribe((result) => {
         if (result.data) {
            this.callRetentionPolicyTypeId = result.data.account.callRetentionPolicyTypeId;
            this.hideRecordingDate = setHideRecordingDate(this.callRetentionPolicyTypeId);
         }
      });
   }

   onFilterChange(filterValues: {
      startDate: Date | null;
      endDate: Date | null;
      fromDuration: number;
      toDuration: number;
      callDisposition: CallDispositionTypes;
      callDirection: CallDirectionTypes;
      extensionGroupExtensions: number[];
   }): void {
      const { startDate, endDate, fromDuration, toDuration, callDisposition, callDirection, extensionGroupExtensions } =
         filterValues;
      this.registerOptions = {
         ...this.registerOptions,
         endDate: endDate ?? undefined,
         fromDuration,
         startDate: startDate ?? undefined,
         toDuration,
         callDisposition,
         callDirection,
         extensionGroupExtensions,
      };
      this.quickFilterChange.emit(this.registerOptions);
   }
}
